module.exports = __webpack_public_path__ + "img/tks.35ab33ed.png";